import { Badge, Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/VictorBracco.jpg";

const VictorBracco: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <div className='d-flex flex-row align-items-center mb-2'>
        <img
          className='rounded-circle mr-2'
          width={92}
          alt='Foto de perfil de Victor Bracco'
          height={92}
          src={ProfilePicture}
        />
        <div>
          <h1>Victor Bracco</h1>
          <h3 className='text-muted'>Back-End team</h3>
        </div>
      </div>
      <p>
        Hola, soy Victor Bracco, parte del equipo de backend. En la empresa
        estoy haciendo staffing, manteniendo un sitio en PHP y desarrollando
        nuevas api en nodejs.
      </p>
      <p>
        Soy un entusiasta de la programación. Emprendedor empedernido. Programo
        desde que tengo 15 años (hoy 37), dando mis primeros pasos con FoxPro,
        pasando por Pascal y Visual Basic llegando hasta PHP, Python y hoy
        Nodejs.
      </p>
      <p>
        Algunas de las tecnologías que manejo son{" "}
        <Badge className='mr-1' variant='primary'>
          php
        </Badge>
        <Badge className='mr-1' variant='info'>
          nodejs
        </Badge>
        <Badge className='mr-1' variant='danger'>
          python
        </Badge>
      </p>
    </Container>
  );
};

export default new Content({
  Component: VictorBracco,
  title: "Victor Bracco",
  route: "victor-bracco",
  tags: [
    "semi-senior",
    "php",
    "mysql",
    "javascript",
    "node",
    "nodejs",
    "mongodb",
    "mongoose",
    "aws",
    "git",
    "python",
    "npm"
  ]
});
